
//import {_serviceUrl,_appUrl,_version,_said,_sizerType,_sizerName,_launcher,_launcherClass} from './SizerUI/SizerConfig/Config'
import {_serviceUrl,_version,_appUrl,_said,_title,_basename,_landingUrl} from './SizerUI/SizerConfig/Config'
export const supportEmail = "ese_aa_solutions@hpe.com";
export const serviceUrl = _serviceUrl;
export const appUrl = _appUrl;
export const version = _version;
export const said = _said;
export const title = _title;
export const basename = _basename;
export const landingUrl = _landingUrl;
export const logOutAttribute = 'ssoLoggedOut';
//export const redirection_Link = 'hc9w03273.itcs.hpe.com'
//export const redirection_Link = 'solutionsizers.ext.hpe.com'
export const redirection_Link = window.location.host;
// export const sizerType = _sizerType;             
// export const sizerName = _sizerName ;
// export const launcher = _launcher ;
// export const launcherClass = _launcherClass ;







// WEBPACK FOOTER //
// ./src/AppConfig.js